import React, {  Component } from 'react'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';

export class Device_Setup extends Component {

    
    constructor(props) 
    {
        
        super(props)

        this.state = {
              GroupId:'',
              TimeZoneId:'',
              ActionId:'1',
              DstatusId:'0',
              DID:'0',
              DActionname:'Save',
              GroupData:[],
              TimeZoneData:[],
              StatusData:[],
              DeviceData:[],
              API_URL:aPIURL(),
              AUTH_URL:auTHURL(),
       deviceInfo: {
                
                DIMEI: "",
                DModel: "",
                DeviceName: "",
                DevMobile: "",
                DGroup: "",
                DTimeZone: "",
                DStatus: false,
                Dremark: ""
        
              }
        }
    }
    
    componentDidMount() {
        //alert("hi"); 
        //alert(this.state.API_URL+'GpsDeviceGroup'); 
            axios.post(this.state.API_URL+'GpsDeviceGroup').then(response => {
                      
            this.setState({ GroupData: response.data.data });
            this.setState({ GroupId :"1" });
console.log("------------------------------Group ");
        }).catch(function(error){console.log(error.message);});

        axios.post(this.state.API_URL+'TimeZone').then(response => {           
                      
            this.setState({ TimeZoneData: response.data.data });  
            this.setState({ TimeZoneId: "+5:30" });  
                      
            console.log("------------------------------Timezone ");
        }).catch(function(error){console.log(error.message);});

        axios.post(this.state.API_URL+'GpsDeviceAllList/').then(response => {          
                       
            this.setState({
                DeviceData: response.data.data,
            });
            console.log("------------------------------device ");
        }).catch(function(error){console.log(error.message);});

        this.setState({
            StatusData: [{displayName: "Enabled", statusValue: "1",  stausId: 1},{displayName: "Disabled", statusValue: "0",  stausId: 0}],

        });
    }
   
    
    onClickRegister = () => {
       
        if(this.state.deviceInfo.DModel==='')
        {
            toast.error("Device model is required.");
            return;
        }
       else if(!this.state.deviceInfo.DIMEI)
        {
           {/* toast.error("Device IMEI is Required.",{ position: "bottom-right", autoClose: 4000, theme: "light"}); */}
           toast.error("Device IMEI is required.");
           return;
        }
        
        else if(!this.state.GroupId)
        {
            toast.error("Group is required.");
            return;
        }
        else if(this.state.GroupId==='')
        {
            toast.error("Group is required.");
            return;
        }
        
        else if(this.state.DstatusId==='')
        {
            toast.error("Status is required.");
            return;
        }       
      else  
      {
       if(this.state.ActionId==='1')
       {
           alert(this.state.GroupId);
           //Insert Device Details
           const params = JSON.stringify({
    
          "iemiNumber": this.state.deviceInfo.DIMEI,
          "deviceName": "GPS",
          "mobileNumber": this.state.deviceInfo.DevMobile,
          "model": this.state.deviceInfo.DModel,
          "goupID": this.state.GroupId,
          "timeZone": this.state.TimeZoneId,
          "createdBy": "admin",
          "is_Active": this.state.DstatusId,
          "remarks": this.state.deviceInfo.Dremark
        });
         

        axios.post(this.state.API_URL+'GpsDeviceRegistration/', params, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
                toast.success(response.data.message);             
                
          })
    
          .catch(function (error) 
          {
                //alert(error.message);
                //toast.error("Some Error occured while saving record.");
                //toast.error(error);
                console.log(error);    
          });
            console.log(this.state);
            this.handleClear();
            
        } 
        else
        {
            
             //Update Device Details
           const params = JSON.stringify({
            "id": this.state.DID,
            "iemiNumber": this.state.deviceInfo.DIMEI,
            "deviceName": this.state.deviceInfo.DeviceName,
            "mobileNumber": this.state.deviceInfo.DevMobile,
            "model": this.state.deviceInfo.DModel,
            "goupID": this.state.GroupId,
            "timeZone": this.state.TimeZoneId,
            "createdBy": "admin",
            "is_Active": this.state.DstatusId,
            "remarks": this.state.deviceInfo.Dremark           
           
          });
           
  
          axios.post(this.state.API_URL+'GpsDeviceEdit/', params, {
      
               "headers": 
               {
                      "content-type": "application/json",    
               },
      
          })
          .then(function (response) 
            {
                
                  toast.success(response.data.message);   
               
       
                 
            })      
           .catch(function (error) 
            {
                //alert(error.message);
                //toast.error("Some Error occured while saving record.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
                //toast.error(error,{ position: "bottom-right", autoClose: 4000, theme: "light"});
                console.log(error);    
            });
              console.log(this.state);
              this.handleClear();
              
             
                  
        }
    }
}
    
    

    ChangeDGroup = (e) => {

        this.setState({ GroupId: e.target.value });        
    }

    ChangeTimeZone = (e) => {

        this.setState({ TimeZoneId: e.target.value });  
           
    }
    ChangeDStatus = (e) => {

        this.setState({ DstatusId: e.target.value });      
        
    }
       
    changeHandler = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            deviceInfo: {
            ...this.state.deviceInfo,
            [name]: value
          }
        }
        );
    }

    handleClear=()=>
    {

        this.setState({ ActionId: '1'}); 
        this.setState({ DActionname: 'Save'});
        this.setState({ GroupId: ''}); 
        this.setState({ TimeZoneId: ''});   
        this.setState({ DstatusId: '0'});
        this.setState({ DID: '0'});          
        this.setState({DeviceData: []});    
        this.setState({
            deviceInfo: {
                //...this.state.deviceInfo,                    
                DIMEI: "",
                DModel: "",
                DeviceName: "",
                DevMobile: "",
                DGroup: "",
                DTimeZone: "",
                DStatus: false,
                Dremark: "",
    
                }  });    
                //bind device details grid
                this.bindDeviceDetails();          
    }
    bindDeviceDetails=()=>
    {
       // alert(this.state.ActionId);
        if(this.state.ActionId==1)
        {
            alert("GPS device added successfully.");
        }
        else
        {
            alert("GPS device updated successfully.");
        }
        //grid binding start 
        
        this.setState({DeviceData: []}); 
        axios.post(this.state.API_URL+'GpsDeviceAllList/').then(response => {          
           
            this.setState({
             DeviceData: response.data.data,
             });
         });
       //grid binding end
       
    }
    
    handleEdit=e => {
            
            const D_Id = e.target.id;  
                         
            const urls=this.state.API_URL+`GetDeviceDetails/${D_Id}/`;
            //alert(D_Id);  
            
            axios.post(urls).then(response => 
            {
                console.log("---------------start---------------");
                console.log(response.data.data[0]);                       
                //this.handleClear();

                {/*  const { deviceName,imeiNumber,model,mobileNo,timeZone,status,groupName } = response.data.data[0]; */} 
                this.setState({ ActionId: '2'}); 
                this.setState({ DActionname: 'Update'});
                this.setState({ DID: response.data.data[0].id});  
                this.setState({ GroupId: response.data.data[0].groupID}); 
                this.setState({ TimeZoneId: response.data.data[0].timeZone});   
                this.setState({ DstatusId: response.data.data[0].is_Active});  
                console.log(response.data.data[0].id);
                 
                this.setState({
                    deviceInfo: {
                        //...this.state.deviceInfo,                    
                        DIMEI: response.data.data[0].iemiNumber,
                        DModel: response.data.data[0].model,
                        DeviceName: response.data.data[0].deviceName,
                        DevMobile: response.data.data[0].mobileNumber,
                        DGroup: response.data.data[0].goupID,
                        DTimeZone: response.data.data[0].timeZone,
                        DStatus: response.data.data[0].is_Active,
                        Dremark: response.data.data[0].remarks,
            
                        }  });                                                        
            });          
    }
    styles = {
        headsection: {
            backgroundColor:"black", color:"white",textAlign:"center"
        },
        wrapper: {
          textAlign: "center",
          margin: "0 auto",
          marginTop: "50px"
        }
      }
    render() {

        return (
            <>

      <div class="row">      
		<div class="col-sm-6 col-md-3 form-group">
		Model<span style={{color:"red"}}>&nbsp;*</span>
        <input name="DModel" type="text" required="required" className="form-control" value={this.state.deviceInfo.DModel} onChange={this.changeHandler} ></input>
	    </div>
		
        <div class="col-sm-6 col-md-3 form-group">
		Device IMEI<span style={{color:"red"}}>&nbsp;*</span>        
        <input name="DIMEI"  type="text" required="required"  className="form-control" maxLength={16} value={this.state.deviceInfo.DIMEI} onChange={this.changeHandler} ></input>
		</div>
		
		<div class="col-sm-6 col-md-3 form-group">
		SIM Number
        <input name="DevMobile" type="text" required="required" className="form-control" maxLength={10} value={this.state.deviceInfo.DevMobile} onChange={this.changeHandler} ></input>
		</div>
		
		<div class="col-sm-6 col-md-3 form-group">
		Group<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control" name="DGroup" value={this.state.GroupId} onChange={this.ChangeDGroup}  >
         
         {this.state.GroupData.map((e, key) => {
         return <option key={key} value={e.groupID}>{e.groupName}</option>;
         })}
        </select>
		</div>
		<div class="col-sm-6 col-md-3 form-group">
		Time-Zone<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control slct" name="DSTimeZone" value={this.state.TimeZoneId} onChange={this.ChangeTimeZone} >
             {this.state.TimeZoneData.map((e, key) => {
             return <option key={key} value={e.timeValue}>{e.displayName}</option>;
            })}

        </select>
		</div>
		<div class="col-sm-6 col-md-3 form-group">
		Status<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control slct" name="DStatus" value={this.state.DstatusId} onChange={this.ChangeDStatus} >
           
           {this.state.StatusData.map((e, key) => {
             return <option key={key} value={e.statusValue}>{e.displayName}</option>;
            })}

        </select>
        {/* <br/> <br/>
       
        <label><input name="rStatus" type="radio"  value={this.state.deviceInfo.DStatus} onChange={this.onOptionChange} />Active</label>
        &nbsp;&nbsp;
        <label><input name="rStatus" checked="true" type="radio"  value={this.state.deviceInfo.DStatus} onChange={this.onOptionChange} /> Inactive</label>         
        */}
   	</div>
	<div class="col-sm-6 col-md-6 form-group">
    Remarks
        <input name="Dremark" type="text" className="form-control" value={this.state.deviceInfo.Dremark} onChange={this.changeHandler} ></input>
	</div>
  
    <div class="col-sm-12 col-md-12 form-group">
    <center>
        
                    <button type="submit" id="Save" onClick={this.onClickRegister} className="btn btn-primary">{this.state.DActionname} </button>
                    {/* <button type="submit" id="btnupdate" onClick={this.onClickUpdate} className="btn login-btn">Update</button> */}
       
    </center>
    </div>
	</div>
    <div class="row">
    <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                <th style={ this.styles.headsection }>Device Name</th>
                <th style={ this.styles.headsection }>Model</th>
                <th style={ this.styles.headsection }>Device IMEI</th>
                <th style={ this.styles.headsection }>Mobile Number</th>
                <th style={ this.styles.headsection }>Group </th>
                <th style={ this.styles.headsection }>Time-Zone</th>
                <th style={ this.styles.headsection }>Activation Date</th>
                <th style={ this.styles.headsection }>Expiration Date</th>
                <th style={ this.styles.headsection }>Status</th>
                <th style={ this.styles.headsection }>#</th>
            </tr>
        </thead>
        <tbody>

        {this.state.DeviceData.map(devdata => (
            <tr key={devdata.id}>
              <td>{devdata.deviceName}</td>
              <td>{devdata.model}</td> 
              <td style={{textAlign:"center"}}>{devdata.imeiNumber}</td>
              <td style={{textAlign:"center"}}>{devdata.mobileNo}</td>
              <td>{devdata.groupName}</td>
              <td style={{textAlign:"center"}}>{devdata.timeZone}</td>
              <td style={{textAlign:"center"}}>{devdata.activationDate}</td>
              <td style={{textAlign:"center"}}>{devdata.expirationDate}</td>
              <td style={{textAlign:"center"}}>{devdata.status}</td>
              <td style={{textAlign:"center"}}>
              <button id={devdata.id} onClick={this.handleEdit} style={{ border:"none", color:"green",background:"Transparent", padding:"0px" ,"font-weight":"bold" }} title="Edit" >   
                Edit                         
              </button>             
                 
                
                {/*
                <button id={devdata.id} onClick={this.handleEdit}  className="btn login-btn">Edit</button> 
                */}

                </td>
              
            </tr>
          ))
          }
            
            </tbody>
            </table>
    </div>
    <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>
    </>
    );

    }

}


export default Device_Setup  